import cx from "classnames";
import React from "react";
import styles from "./embed.scss";

export default function TitleBar(props) {
  let { eventUrl, heading, subHeading, brandedLogoPath, hideLogo } = props;
  let title = eventUrl ? (
    <a href={eventUrl} target="_blank">
      {heading}
    </a>
  ) : (
    heading
  );
  return (
    <div className={styles.TitleBar}>
      <h1>{title}</h1>
      <h2>{subHeading}</h2>
      {!hideLogo && (
        <a href={eventUrl || "https://ridewithgps.com"} target="_blank">
          <img
            className={cx(styles.BrandImg, brandedLogoPath && styles.brandedLogo)}
            src={brandedLogoPath || "/images/logos/horizontal-logo.svg"}
            width={!brandedLogoPath && "100"}
            height={!brandedLogoPath && "24"}
          />
        </a>
      )}
    </div>
  );
}
